import { usePatchProgram } from '../data/usePatchProgram';

export function useChangeProgram(applicationId: string) {
  const { patchProgram } = usePatchProgram(applicationId);

  async function changeProgram(newProgramIntakeId: string) {
    return await patchProgram({
      programSelected: {
        priority: 1,
        programIntakeId: newProgramIntakeId,
      },
    });
  }

  return {
    changeProgram,
  };
}
